import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, FlaskConical } from "lucide-react";

export function Layout({ children, nav = [], showTestButton = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 border-b border-border bg-white/85 backdrop-blur-xl dark:bg-slate-900/85">
        <div className="mx-auto flex h-16 max-w-[1600px] items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-8">
            <Logo />
            <nav className="hidden items-center gap-1 md:flex">
              {nav.map((item) => {
                const active = location.pathname === item.to;
                return (
                  <button key={item.to} onClick={() => navigate(item.to)}
                    data-testid={`nav-${item.key}`}
                    className={`rounded-lg px-3 py-2 text-sm font-medium transition-colors ${active ? "bg-sky-50 text-sky-700 dark:bg-sky-950 dark:text-sky-300" : "text-muted-foreground hover:bg-muted hover:text-foreground"}`}>
                    {item.label}
                  </button>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            {showTestButton && (
              <Button variant="outline" size="sm" onClick={() => navigate("/search?test=1")}
                data-testid="test-dispenser-view-toggle" className="hidden sm:flex">
                <FlaskConical className="mr-1.5 h-4 w-4" /> Test Dispenser View
              </Button>
            )}
            <div className="hidden text-right sm:block">
              <div className="text-sm font-semibold leading-tight text-foreground">{user?.name}</div>
              <div className="text-[11px] uppercase tracking-wide text-muted-foreground">
                {user?.role?.replace("_", " ")}{user?.branch?.name ? ` · ${user.branch.name}` : ""}
              </div>
            </div>
            <Button variant="ghost" size="icon" onClick={logout} data-testid="logout-button" title="Sign out">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
        {nav.length > 0 && (
          <nav className="flex gap-1 overflow-x-auto border-t border-border px-4 py-2 md:hidden canda-scroll">
            {nav.map((item) => (
              <button key={item.to} onClick={() => navigate(item.to)}
                className={`whitespace-nowrap rounded-lg px-3 py-1.5 text-sm font-medium ${location.pathname === item.to ? "bg-sky-50 text-sky-700" : "text-muted-foreground"}`}>
                {item.label}
              </button>
            ))}
          </nav>
        )}
      </header>
      <main className="mx-auto max-w-[1600px] px-4 py-8 sm:px-6 lg:px-8">{children}</main>
    </div>
  );
}
